export default "__VITE_ASSET__DoOqAFRr__"